import Backdrop, {type BackdropProps} from "@mui/material/Backdrop";
import React from "react";

const DialogBackdropNoCloseOnClick = React.forwardRef<HTMLDivElement, BackdropProps>((props, ref) => {
    const {onClick: _onClick, ...other} = props;
    // Drop onClick so backdrop clicks don't trigger modal close.
    return React.createElement(Backdrop, {...other, ref});
});

DialogBackdropNoCloseOnClick.displayName = "DialogBackdropNoCloseOnClick";

export default DialogBackdropNoCloseOnClick;
